<svg width="10" viewBox="0 0 160 159" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="71" width="18" height="159" fill="black" />
  <rect x="159.5" y="70.5" width="18" height="159" transform="rotate(90 159.5 70.5)" fill="black" />
</svg>
